const ko = {
  "프로필 수정": "프로필 수정",
  "안녕하세요.": "안녕하세요.",
  "{{name}}님": "{{name}}님",
  "검색": "검색",
  "전체": "전체",
  "성명, 소속, 이메일로 검색할 수 있습니다.": "성명, 소속, 담당업무, 이메일로 검색할 수 있습니다.",
  "검색어를 입력하세요.": "검색어를 입력하세요.",
  "성명을 입력하세요.": "성명을 입력하세요.",
  "소속을 입력하세요.": "소속을 입력하세요.",
  "담당 업무를 입력하세요.": "담당 업무를 입력하세요.",
  "이메일을 입력하세요.": "이메일을 입력하세요.",
  "휴대폰번호를 입력하세요.": "휴대폰번호를 입력하세요.",
  "성명": "성명",
  "소속": "소속",
  "근무처": "근무처",
  "직위/직책": "직위/직책",
  "담당 업무": "담당 업무",
  "휴대폰번호": "휴대폰번호",
  "내선번호": "내선번호",
  "이메일": "이메일",
  "클립보드에 복사되었습니다.": "클립보드에 복사되었습니다.",
  "휴대폰번호 복사": "휴대폰번호 복사",
  "이메일 복사": "이메일 복사",
  "검색 결과가 없습니다.": "검색 결과가 없습니다.",
  "페이지에 접근할 수 있는 권한이 없습니다.": "페이지에 접근할 수 있는 권한이 없습니다.",
  "임직원 검색": "임직원 검색",
  "결과를 고르면 오른쪽에 전체 정보가 표시됩니다": "결과를 고르면 오른쪽에 전체 정보가 표시됩니다",
  "결과를 고르면 아래에 전체 정보가 표시됩니다": "결과를 고르면 아래에 전체 정보가 표시됩니다",
  "이름/소속명/담당업무/이메일/휴대폰번호 검색": "이름/소속명/담당업무/이메일/휴대폰번호 검색",
  "총 {{count}}명": "총 {{count}}명",
  "조직도": "조직도",
  "{{name}}에서 보기": "{{name}}에서 보기",
  "클릭하면 {{name}}로 이동합니다": "클릭하면 {{name}}로 이동합니다",
  "직무": "직무",
  "연락처": "연락처",
  "직위": "직위",
  "직책": "직책",
  "복사": "복사",
  "선택된 임직원이 없습니다": "선택된 임직원이 없습니다",
  "왼쪽 목록에서 임직원을 선택하세요": "왼쪽 목록에서 임직원을 선택하세요",
  "위 목록에서 임직원을 선택하세요": "위 목록에서 임직원을 선택하세요",
  "계정변경": "계정변경",
  "로그아웃": "로그아웃",
  "부서 및 임직원": "부서 및 임직원",
  "조직도를 불러오는데 실패했습니다.": "조직도를 불러오는데 실패했습니다.",
  "관리자": "관리자",
  "언어 선택": "언어 선택",
  "기업 선택": "기업 선택",
  "릴리즈 노트": "릴리즈 노트",
  "매뉴얼": "매뉴얼",
  "매뉴얼 선택": "매뉴얼 선택",
  "권한 관리": "권한 관리",
  "권한": "권한",
  "사용자별 보기": "사용자별 보기",
  "권한별 보기": "권한별 보기",
  "권한 검색": "권한 검색",
  "보유자": "보유자",
  "보유한 권한": "보유한 권한",
  "권한 부여": "권한 부여",
  "권한 회수": "권한 회수",
  "권한 부여 확인": "권한 부여 확인",
  "권한 회수 확인": "권한 회수 확인",
  "권한이 부여되었습니다.": "권한이 부여되었습니다.",
  "권한이 회수되었습니다.": "권한이 회수되었습니다.",
  "변경 실패. 잠시 후 다시 시도해주세요.": "변경 실패. 잠시 후 다시 시도해주세요.",
  "권한 정보를 불러오지 못했습니다.": "권한 정보를 불러오지 못했습니다.",
  "사용자 정보를 불러오지 못했습니다.": "사용자 정보를 불러오지 못했습니다.",
  "보유자가 없습니다.": "보유자가 없습니다.",
  "사용자 또는 권한을 선택하세요": "사용자 또는 권한을 선택하세요",
  "좌측에서 사용자나 권한을 선택하면 상세를 확인할 수 있습니다.": "좌측에서 사용자나 권한을 선택하면 상세를 확인할 수 있습니다.",
  "시스템 관리자": "시스템 관리자",
  "법인 관리자": "법인 관리자",
  "메뉴 관리자": "메뉴 관리자",
  "기타 권한": "기타 권한",
  "추가할 권한": "추가할 권한",
  "제거할 권한": "제거할 권한",
  "변경 전": "변경 전",
  "변경 후": "변경 후",
  "부여된 그룹": "부여된 그룹",
  "펼치기": "펼치기",
  "접기": "접기",
  "그룹 멤버십을 통해 부여됨": "그룹 멤버십을 통해 부여됨",
  "부여 경로": "부여 경로",
  "직접": "직접",
  "그룹 경유": "그룹 경유",
  "포함하는 권한": "포함하는 권한",
  "포함되는 권한": "포함되는 권한",
  "함께 부여됨": "함께 부여됨",
  "자동 부여 출처": "자동 부여 출처",
  "부여 시 자동 포함": "부여 시 자동 포함",
  "상위 권한 보유자가 자동 보유": "상위 권한 보유자가 자동 보유",
  "없음": "없음",
  "현재 보유 권한": "현재 보유 권한",
  "권한 추가/회수": "권한 추가/회수",
  "체크박스로 부여, 다시 클릭으로 회수": "체크박스로 부여, 다시 클릭으로 회수",
  "변경 사항 검토": "변경 사항 검토",
  "변경 사유": "변경 사유",
  "변경 사유를 입력하세요": "변경 사유를 입력하세요",
  "사용자를 선택하세요": "사용자를 선택하세요",
  "권한을 선택하세요": "권한을 선택하세요",
  "추가할 사용자를 검색하세요": "추가할 사용자를 검색하세요",
  "상위 역할": "상위 역할",
  "서비스 계정": "서비스 계정",
  "직접 회수 불가": "직접 회수 불가",
  "그룹 또는 상위 역할을 통해 부여됨": "그룹 또는 상위 역할을 통해 부여됨",
  "직접 부여만 보기": "직접 부여만 보기",
  "이름 또는 이메일 검색": "이름 또는 이메일 검색",
  "취소": "취소",
  "저장": "저장",
  "회수": "회수",
  "보유자 추가": "보유자 추가",
  "법인 필터": "법인 필터",
  "총 {{count}}건": "총 {{count}}건",
  "{{count}}명": "{{count}}명",
  "{{count}}개": "{{count}}개",
  "외 {{count}}개": "외 {{count}}개",
  "이름": "이름",
  "법인": "법인",
  "고용 상태": "고용 상태",
  "관리": "관리",
  "데이터를 불러오고 있습니다.": "데이터를 불러오고 있습니다.",
  "사용자 검색": "사용자 검색",
  "활성": "활성",
  "퇴직": "퇴직",
  "승인대기": "승인대기",
  "다시 시도": "다시 시도",
  "사용자 목록을 불러오지 못했습니다.": "사용자 목록을 불러오지 못했습니다.",
  "퇴직자가 없습니다.": "퇴직자가 없습니다.",
  "이름·이메일·사번·UUID": "이름·이메일·사번·UUID",
  "이름·이메일·사번·UUID로 검색하거나 법인 필터를 선택하세요.": "이름·이메일·사번·UUID로 검색하거나 법인 필터를 선택하세요.",
  "사번": "사번",
  "휴대폰": "휴대폰",
  "사무실": "사무실",
  "가입 승인 관리": "가입 승인 관리",
  "이름 · 이메일 검색": "이름 · 이메일 검색",
  "인증 완료": "인증 완료",
  "인증 미완료": "인증 미완료",
  "조건에 맞는 신청 건이 없습니다.": "조건에 맞는 신청 건이 없습니다.",
  "검색 조건을 변경해 주세요.": "검색 조건을 변경해 주세요.",
  "{{count}}명 선택됨": "{{count}}명 선택됨",
  "선택 해제": "선택 해제",
  "일괄 승인": "일괄 승인",
  "전체 선택": "전체 선택",
  "이메일 인증 상태": "이메일 인증 상태",
  "전화번호": "전화번호",
  "신청일시": "신청일시",
  "승인/거절": "승인/거절",
  "승인": "승인",
  "거절": "거절",
  "그룹을 선택해주세요.": "그룹을 선택해주세요.",
  "가입승인 - 그룹 지정": "가입승인 - 그룹 지정",
  "일괄 승인 - 그룹 지정 ({{count}}명)": "일괄 승인 - 그룹 지정 ({{count}}명)",
  "승인에 실패했습니다. 잠시 후 다시 시도해주세요.": "승인에 실패했습니다. 잠시 후 다시 시도해주세요.",
  "가입거절": "가입거절",
  "가입 거절 시, 해당 계정이 삭제됩니다.": "가입 거절 시, 해당 계정이 삭제됩니다.",
  "계정을 삭제하시겠습니까?": "계정을 삭제하시겠습니까?",
  "더보기": "더보기",
  "일": "일",
  "월": "월",
  "화": "화",
  "수": "수",
  "목": "목",
  "금": "금",
  "토": "토",
  "{{year}}년 {{month}}월": "{{year}}년 {{month}}월",
  "이전 달": "이전 달",
  "다음 달": "다음 달",
  "지우기": "지우기",
  "오늘": "오늘",
  "날짜 선택": "날짜 선택",
  "기간 선택": "기간 선택",
  "{{count}}일": "{{count}}일",
  "{{date}} 부터 · 종료일을 고르세요": "{{date}} 부터 · 종료일을 고르세요",
  "시작일을 고르세요": "시작일을 고르세요",
  "연도-월-일": "연도-월-일",
  "달력 열기": "달력 열기",
  "{{year}}년": "{{year}}년",
  "이전 해": "이전 해",
  "다음 해": "다음 해",
  "이전 연도 목록": "이전 연도 목록",
  "다음 연도 목록": "다음 연도 목록",
  "1월": "1월",
  "2월": "2월",
  "3월": "3월",
  "4월": "4월",
  "5월": "5월",
  "6월": "6월",
  "7월": "7월",
  "8월": "8월",
  "9월": "9월",
  "10월": "10월",
  "11월": "11월",
  "12월": "12월",
  "소속 협력사": "소속 협력사",
  "이름 · 이메일 · 소속 검색": "이름 · 이메일 · 소속 검색"
};
export {
  ko as default
};
